import { useEffect, useState } from "react";

// CAPS standard for structured business data (never for email / URL / notes / passwords)
export const up = (v) => (v == null ? "" : String(v).toUpperCase());

export const useDebounced = (value, ms = 400) => {
  const [v, setV] = useState(value);
  useEffect(() => { const t = setTimeout(() => setV(value), ms); return () => clearTimeout(t); }, [value, ms]);
  return v;
};
